export const PAGE_SIZE = 10;

// Cursor format is a contract with the dex backend's `_encode_cursor`
// (dex/api/gql/pipeline_status.py): base64 of `arrayconnection:{offset}`.
export const offsetToCursor = (offset: number): string => btoa(`arrayconnection:${offset}`);

// `after` is exclusive, so a page's cursor is the row BEFORE its first; page 1 has none.
// Synthesized from offsets for random page access, which can skip/duplicate a boundary
// row if the total shifts mid-browse (acceptable for this admin table).
export const afterCursorForPage = (page: number): string | undefined =>
  page <= 1 ? undefined : offsetToCursor((page - 1) * PAGE_SIZE - 1);
